import React, { useState } from 'react';
import './PricingAndStates.css';

const PricingAndStates = ({
  badge = "Pricing Table",
  title = "Choose Your Learning Plan",
  subtitle = "Select the package that fits your requirements.",
  hideStates = false,
  defaultCurrency = null,  // 'USD' or 'CAD' — when set, hides the toggle and locks the currency
  onOpenModal = null,       // when provided, pricing buttons open the modal instead of navigating
  isUsaPage = false
}) => {
  const [currency, setCurrency] = useState(defaultCurrency || 'USD');

  const usdPlans = [
    {
      discount: '20% OFF',
      price: 25,
      features: [
        '1 Lesson per Week',
        '4 Lessons per Month',
        'Duration 30 Minutes',
        'Monthly progress reports',
        'Certification',
        '24/7 support'
      ]
    },
    {
      discount: '20% OFF',
      price: 35,
      features: [
        '2 Lessons per Week',
        '8 Lessons per Month',
        'Duration 30 Minutes',
        'Monthly progress reports',
        'Certification',
        '24/7 support'
      ]
    },
    {
      discount: '20% OFF',
      price: 45,
      features: [
        '2 Lessons every Weekend (Sat – Sun)',
        '8 Lessons per Month',
        'Duration 30 Minutes',
        'Monthly progress reports',
        'Certification',
        '24/7 support'
      ]
    },
    {
      discount: 'MOST POPULAR',
      isPopular: true,
      price: 48,
      features: [
        '3 Lessons per Week',
        '12 Lessons per Month',
        'Duration 30 Minutes',
        'Monthly progress reports',
        'Certification',
        '24/7 support'
      ]
    },
    {
      discount: '20% OFF',
      price: 65,
      features: [
        '4 Lessons per Week',
        '16 Lessons per Month',
        'Duration 30 Minutes',
        'Monthly progress reports',
        'Certification',
        '24/7 support'
      ]
    },
    {
      discount: '20% OFF',
      price: 80,
      features: [
        '5 Lessons per Week',
        '20 Lessons per Month',
        'Duration 30 Minutes',
        'Monthly progress reports',
        'Certification',
        '24/7 support'
      ]
    }
  ];

  const cadPlans = [
    {
      discount: '20% OFF',
      price: 25,
      features: [
        '1 Lesson per Week',
        '4 Lessons per Month',
        'Duration 30 Minutes',
        'Monthly progress reports',
        'Certification',
        '24/7 support'
      ]
    },
    {
      discount: '20% OFF',
      price: 35,
      features: [
        '2 Lessons per Week',
        '8 Lessons per Month',
        'Duration 30 Minutes',
        'Monthly progress reports',
        'Certification',
        '24/7 support'
      ]
    },
    {
      discount: '20% OFF',
      price: 45,
      features: [
        '2 Lessons every Weekend (Sat – Sun)',
        '8 Lessons per Month',
        'Duration 30 Minutes',
        'Monthly progress reports',
        'Certification',
        '24/7 support'
      ]
    },
    {
      discount: 'MOST POPULAR',
      isPopular: true,
      price: 50,
      features: [
        '3 Lessons per Week',
        '12 Lessons per Month',
        'Duration 30 Minutes',
        'Monthly progress reports',
        'Certification',
        '24/7 support'
      ]
    },
    {
      discount: '20% OFF',
      price: 65,
      features: [
        '4 Lessons per Week',
        '16 Lessons per Month',
        'Duration 30 Minutes',
        'Monthly progress reports',
        'Certification',
        '24/7 support'
      ]
    },
    {
      discount: '20% OFF',
      price: 80,
      features: [
        '5 Lessons per Week',
        '20 Lessons per Month',
        'Duration 30 Minutes',
        'Monthly progress reports',
        'Certification',
        '24/7 support'
      ]
    }
  ];

  const pricingPlans = currency === 'USD' ? usdPlans : cadPlans;

  return (
    <div
      className="pricing-states-wrapper"
      style={{
        '--bg-parallax': `url('${process.env.PUBLIC_URL}/assets/images/Hero-4.jpg')`
      }}
    >
      {/* SECTION 1: Pricing Table */}
      <section className="pricing-section" id="pricing">
        <div className="pricing-section__container">
          <div className="pricing-section__badge">{badge}</div>
          <h4 className="pricing-section__title">{title}</h4>
          <p className="pricing-section__subtitle">{subtitle}</p>

          {/* Currency Toggle — hidden when currency is locked by parent */}
          {!defaultCurrency && (
            <div className="pricing-section__toggle-container">
              <button
                className={`pricing-section__toggle-btn ${currency === 'USD' ? 'pricing-section__toggle-btn--active' : ''}`}
                onClick={() => setCurrency('USD')}
              >
                United States (USD)
              </button>
              <button
                className={`pricing-section__toggle-btn ${currency === 'CAD' ? 'pricing-section__toggle-btn--active' : ''}`}
                onClick={() => setCurrency('CAD')}
              >
                Canada (CAD)
              </button>
            </div>
          )}

          {/* Pricing Grid */}
          <div className="pricing-section__grid">
            {pricingPlans.map((plan, index) => {
              const price = plan.price;
              const symbol = '$';
              return (
                <div key={index} className="pricing-card">
                  <div className="pricing-card__header">
                    <div className="pricing-card__badge-row">
                      <span className={`pricing-card__discount ${plan.isPopular ? 'pricing-card__discount--popular' : ''}`}>
                        {plan.discount}
                      </span>
                      {/* Bulb Icon */}
                      <div className="pricing-card__icon-wrapper">
                        <svg className="pricing-card__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" xmlns="http://www.w3.org/2000/svg">
                          <path d="M15 14c.2-1 .7-1.7 1.5-2.5 1-.9 1.5-2.2 1.5-3.5A5 5 0 0 0 8 8c0 1.3.5 2.6 1.5 3.5.8.8 1.3 1.5 1.5 2.5" />
                          <line x1="9" y1="18" x2="15" y2="18" />
                          <line x1="10" y1="22" x2="14" y2="22" />
                        </svg>
                      </div>
                    </div>
                    <div className="pricing-card__price">
                      <span className="pricing-card__amount">{symbol}{price}</span>
                      <span className="pricing-card__period">/Month</span>
                    </div>
                  </div>

                  <ul className="pricing-card__features">
                    {plan.features.map((feature, fIndex) => (
                      <li key={fIndex} className="pricing-card__feature-item">
                        <svg className="pricing-card__feature-check" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                          <path fillRule="evenodd" d="M16.704 4.153a.75.75 0 01.143 1.052l-8 10.5a.75.75 0 01-1.127.075l-4.5-4.5a.75.75 0 011.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 011.05-.143z" clipRule="evenodd" />
                        </svg>
                        <span>{feature}</span>
                      </li>
                    ))}
                  </ul>

                  <div className="pricing-card__cta">
                    {onOpenModal ? (
                      <button
                        onClick={onOpenModal}
                        className="pricing-card__btn"
                        style={{ border: 'none', cursor: 'pointer', width: '100%' }}
                      >
                        Try For Free
                      </button>
                    ) : (
                      <a href="/free-trial/" className="pricing-card__btn">
                        Try For Free
                      </a>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* SECTION 2: Online Quran Classes — US States or Canada Provinces */}
      {!hideStates && (
        <section className="us-states-section" id="states">
          <div className="pricing-section__container us-states__grid">

            {/* Left Column: Image */}
            <div className="us-states__image-container">
              <img
                src={`${process.env.PUBLIC_URL}/assets/images/Online-Quran-Classes-USA.jpeg`}
                alt=" Online-Quran-Classes-USA"
                className="us-states__img"
              />
            </div>

            {/* Right Column: Copy */}
            <div className="us-states__info">
              {defaultCurrency === 'CAD' ? (
                <>
                  <h2 className="us-states__title">
                    Online Quran Classes Available <span className="us-states__title--green">Across All Canada</span>
                  </h2>

                  <p className="us-states__desc">
                    Al Quran Lesson serves Muslim students and families in every province and territory across Canada. Because our classes are entirely online and live, your location within Canada does not limit your access to quality Quranic education. We serve students in all major and minor cities across Canada.
                  </p>

                  <p className="us-states__desc">
                    No matter where you live, if you have a device and an internet connection, your child's Quran education can start today.
                  </p>

                  {onOpenModal ? (
                    <button onClick={onOpenModal} className="us-states__cta-btn" style={{ border: 'none', cursor: 'pointer' }}>
                      <span>Get Free Trial Classes</span>
                      <svg className="us-states__cta-arrow" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                        <path fillRule="evenodd" d="M3 10a.75.75 0 01.75-.75h10.638L10.22 5.03a.75.75 0 111.06-1.06l5.5 5.5a.75.75 0 010 1.06l-5.5 5.5a.75.75 0 11-1.06-1.06l4.168-4.17H3.75A.75.75 0 013 10z" clipRule="evenodd" />
                      </svg>
                    </button>
                  ) : (
                    <a href="/free-trial/" className="us-states__cta-btn">
                      <span>Get Free Trial Classes</span>
                      <svg className="us-states__cta-arrow" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                        <path fillRule="evenodd" d="M3 10a.75.75 0 01.75-.75h10.638L10.22 5.03a.75.75 0 111.06-1.06l5.5 5.5a.75.75 0 010 1.06l-5.5 5.5a.75.75 0 11-1.06-1.06l4.168-4.17H3.75A.75.75 0 013 10z" clipRule="evenodd" />
                      </svg>
                    </a>
                  )}
                </>
              ) : isUsaPage ? (
                /* USA Landing Page (/usa/) */
                <>
                  <h2 className="us-states__title">
                    Online Quran Classes Available <span className="us-states__title--green">Across All US States</span>
                  </h2>

                  <p className="us-states__desc">
                    Al Quran Lesson serves Muslim students and families in every state across the United States. Because our classes are entirely online and live, your location within the USA does not limit your access to quality Quranic education. We serve students in all minor and major cities and all USA states, including:
                  </p>

                  <p className="us-states__list">
                    Texas | New York | Florida | California | Illinois | New Jersey | Michigan | Ohio | Virginia | Georgia | Pennsylvania | Maryland | North Carolina | Washington | Arizona, and every other state in the US.
                  </p>

                  <p className="us-states__desc">
                    No matter where you live, if you have a device and an internet connection, your child's Quran education can start today.
                  </p>

                  {onOpenModal ? (
                    <button onClick={onOpenModal} className="us-states__cta-btn" style={{ border: 'none', cursor: 'pointer' }}>
                      <span>Get Free Trial Classes</span>
                      <svg className="us-states__cta-arrow" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                        <path fillRule="evenodd" d="M3 10a.75.75 0 01.75-.75h10.638L10.22 5.03a.75.75 0 111.06-1.06l5.5 5.5a.75.75 0 010 1.06l-5.5 5.5a.75.75 0 11-1.06-1.06l4.168-4.17H3.75A.75.75 0 013 10z" clipRule="evenodd" />
                      </svg>
                    </button>
                  ) : (
                    <a href="/free-trial/" className="us-states__cta-btn">
                      <span>Get Free Trial Classes</span>
                      <svg className="us-states__cta-arrow" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                        <path fillRule="evenodd" d="M3 10a.75.75 0 01.75-.75h10.638L10.22 5.03a.75.75 0 111.06-1.06l5.5 5.5a.75.75 0 010 1.06l-5.5 5.5a.75.75 0 11-1.06-1.06l4.168-4.17H3.75A.75.75 0 013 10z" clipRule="evenodd" />
                      </svg>
                    </a>
                  )}
                </>
              ) : (
                /* Home Page */
                <>
                  <h2 className="us-states__title">
                    Learn Quran Online - Available <span className="us-states__title--green">Across All US States & Canada!</span>
                  </h2>

                  <p className="us-states__desc">
                    Because our classes run entirely online, where you live doesn't limit your access to real, structured Quranic education. We currently teach students across <a style={{ textDecoration: "none", color: "#006100", fontWeight: "bold" }} href="/online-quran-classes-texas/">Texas</a>, <a style={{ textDecoration: "none", color: "#006100", fontWeight: "bold" }} href="/online-quran-classes-in-newyork/">New York</a>, Florida, <a style={{ textDecoration: "none", color: "#006100", fontWeight: "bold" }} href="/online-quran-classes-california/">California</a>, Illinois, New Jersey, Michigan, Ohio, Virginia, Georgia, Pennsylvania, Maryland, North Carolina, Washington, Arizona, and every other state in the USA and <a style={{ textDecoration: "none", color: "#006100", fontWeight: "bold" }} href="/online-quran-classes-canada/">Canada</a>.
                  </p>

                  <p className="us-states__desc">
                    If you've got a device and an internet connection, your child's Quran education can start today!
                  </p>

                  <a href="/free-trial/" className="us-states__cta-btn">
                    <span>Get Free Trial Classes</span>
                    <svg className="us-states__cta-arrow" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                      <path fillRule="evenodd" d="M3 10a.75.75 0 01.75-.75h10.638L10.22 5.03a.75.75 0 111.06-1.06l5.5 5.5a.75.75 0 010 1.06l-5.5 5.5a.75.75 0 11-1.06-1.06l4.168-4.17H3.75A.75.75 0 013 10z" clipRule="evenodd" />
                    </svg>
                  </a>
                </>
              )}
            </div>
          </div>
        </section>
      )}
    </div>
  );
};

export default PricingAndStates;

